export default "__VITE_ASSET__B13l5lc2__"